import SwiperSlider from 'swiper/bundle';
// import bootstrap from "bootstrap";

// const bootstrap = require('bootstrap');

class Swiper {
  constructor(el, options) {
    this.el = el;
    this.options = Object.assign({}, options, this.parseDataset());
    this.init();
  }

  parseDataset() {
    let options = {};
    let dataset = this.el.dataset;

    Object.keys(dataset).forEach((key) => {
      let value = dataset[key];

      // Parse nested objects, if needed.
      if (/^(\{|\[)/.test(value)) {
        value = JSON.parse(dataset[key]);
        options[key] = value;
      } else if (/^(true|false)/i.test(value)) {
        options[key] = (dataset[key] === 'true');
      } else if (/^(\d)+/i.test(value)) {
        options[key] = Number.parseInt(dataset[key], 10);
      } else {
        options[key] = dataset[key];
      }
    });

    return options;
  }

  init() {
    // Default options.
    let options = {
      autoplay: false,
      loop: true,
      grabCursor: true,
      touchEventsTarget: 'container'
    };

    options = Object.assign(options, this.options);
    this.swiper = new SwiperSlider(this.el, options);


    // image to modal
    if (this.el.dataset.imageModalTarget) {
      const modalSelector = this.el.dataset.imageModalTarget;
      const modal = document.querySelector(modalSelector);

      const imageModal = new global.bootstrap.Modal(modalSelector, {
        keyboard: false
      });

      this.el.querySelectorAll('[data-slide-id]').forEach(image => {
        image.addEventListener('click', (e) => {
          if (e.target.classList.contains('btn') || e.target.classList.contains('icon')) return;

          const slideId = parseInt(image.dataset.slideId);
          imageModal.show();
          modal.querySelector('.swiper').swiper.slideTo(slideId);
        });
      });
    }
  }
}

function ready() {
  let swipers = document.querySelectorAll('.swiper');

  swipers.forEach((el) => {
    // Custom this options for different modules to get different behaviours.
    let options = {};

    if (el.querySelector('.swiper-pagination')) {
      options = Object.assign(options, {
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
      });
    }

    if (el.querySelector('.swiper-button-next')) {
      options = Object.assign(options, {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }

    new Swiper(el, options);
  });
}

if (document.readyState !== 'loading') {
  ready();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    ready();
  });
}

